export enum AttachmentType {
    AeVerificationImage = 74,
    AeVerificationImage1 = 77,
    SPEsign = 75,
    AeeEsign = 76,
    AdminBookingCancel = 82,
    AdminBookingSenback = 83,
    Pan = 14,
    BankPassBook = 72,
    User = 69,
    Aadhar = 35,
    DealerPremisesPlacementImage = 91,
    DealerPremisesVerificationImage = 92,
    SubsidyPaymentReferenceCopy = 93,
    TelematicsKitImage = 94,
}
